var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { alignItems, display, flex, justifyContent, maxWidth, } from 'styled-system';
import cookieStorage from '../../common/CookieStorage';
import { FlexAlignItems, FlexJustifyContent, FlexWrap, FullWidthBoxShadow, Grid, GridItem, } from '../../common/components/Grid';
import { SideNavSubscription } from '../../common/event-bus/EventSubscription';
import MenuButton from './MenuButton/MenuButton';
import Logo, { ImageFormat } from './Logo/Logo';
import Search from './Search/Search';
import LanguageSwitch from './LanguageSwitch';
import ToolbarActionItem from './ToolbarActionItem';
import { getActionItems, PAYBACK_ACTION_ITEM } from './utils';
var ToolbarGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
ToolbarGrid.defaultProps = {
    alignItems: FlexAlignItems.CENTER,
    justifyContent: FlexJustifyContent.SPACE_BETWEEN,
    flexWrap: [FlexWrap.WRAP, FlexWrap.NO_WRAP],
    py: ['sp_16', 'sp_12'],
};
var LeftSectionGridItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), flex, display, alignItems);
LeftSectionGridItem.defaultProps = {
    as: GridItem,
    w: 'auto',
    alignItems: 'center',
    display: 'flex',
    order: 1,
    flex: 'none',
};
var CenterSectionGridItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), flex, maxWidth);
CenterSectionGridItem.defaultProps = {
    as: GridItem,
    w: [1, 'auto'],
    order: [3, 2],
    maxWidth: [null, '420px', null, '512px'],
    // We are so specific with numbers because of IE
    flex: ['1 0 100%', '1 1 420px', null, '1 1 512px'],
};
var RightSectionGridItem = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), flex, display, justifyContent);
RightSectionGridItem.defaultProps = {
    as: GridItem,
    w: 'auto',
    ml: ['auto', 0],
    display: 'flex',
    order: [2, 3],
    justifyContent: 'flex-end',
    flex: 'none',
};
var Toolbar = function (_a) {
    var __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width, withPaybackActionItem = _a.withPaybackActionItem, customer = _a.customer, restProps = __rest(_a, ["__legacy_shop_reboot_max_width", "withPaybackActionItem", "customer"]);
    var _b = __read(useState(null), 2), customerFromCookie = _b[0], setCustomerFromCookie = _b[1];
    var isLoggedIn = !!customer
        ? customer.isLoggedIn
        : !!(customerFromCookie && customerFromCookie.isLoggedIn);
    var actionItemsProps = __assign({ customer: customer }, restProps);
    var actionItems = withPaybackActionItem
        ? __spread([PAYBACK_ACTION_ITEM], getActionItems(actionItemsProps)) : getActionItems(actionItemsProps);
    useEffect(function () {
        setCustomerFromCookie(cookieStorage.getCustomer());
    }, []);
    return (React.createElement(ToolbarGrid, { "data-testid": "toolbar", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, fullWidthBoxShadow: FullWidthBoxShadow.BOTTOM },
        React.createElement(LeftSectionGridItem, null,
            React.createElement(SideNavSubscription, null, function (_a) {
                var emit = _a.emit;
                return React.createElement(MenuButton, { onClick: function () { return emit(true); } });
            }),
            React.createElement(Logo, { imageFormat: ImageFormat.SVG })),
        React.createElement(CenterSectionGridItem, { maxWidth: 
            // Big size looks weird when we are still "locked"
            // in Reboot land
            __legacy_shop_reboot_max_width
                ? [null, '420px']
                : [null, '420px', null, '512px'] },
            React.createElement(Search, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width })),
        React.createElement(RightSectionGridItem, null,
            actionItems
                .filter(function (_a) {
                var auth = _a.auth;
                return typeof auth === 'undefined' || auth === isLoggedIn;
            })
                .map(function (item) { return (React.createElement(ToolbarActionItem, __assign({ key: item.id }, item))); }),
            React.createElement(LanguageSwitch, null))));
};
Toolbar.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default Toolbar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
